import { Map } from 'immutable';

import {
  SEND_CCB_FOR_USER_SIGNATURE_REQUEST,
  SEND_CCB_FOR_USER_SIGNATURE_FAILURE,
  SEND_CCB_FOR_USER_SIGNATURE_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === SEND_CCB_FOR_USER_SIGNATURE_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], []);
  }

  if (type === SEND_CCB_FOR_USER_SIGNATURE_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === SEND_CCB_FOR_USER_SIGNATURE_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
